import { createTheme } from '@mui/material/styles';
import { ruRU } from '@mui/x-date-pickers/locales';

const theme = createTheme({
  palette: {
    // primary: {
    //   main: '#13BB34',
    // },
    // secondary: {
    //   main: '#D9D9D9',
    // },
  },
  components: {
    MuiSlider: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            color: 'rgb(18, 141, 117)',
            height: 2,
            borderRadius: 0,
            '& .MuiSlider-track': {
              border: 'none',
            },
            '& .MuiSlider-thumb': {
              height: 14,
              width: 14,
              backgroundColor: '#fff',
              border: '4.4px solid currentColor',
              '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                boxShadow: 'inherit',
              },
              '&::before': {
                display: 'none',
              },
            },
            '& .MuiSlider-rail': {
              color: '#f4f5f5',
            },
            '& .MuiSlider-valueLabel': {
              lineHeight: 1.2,
              fontSize: 12,
              background: 'unset',
              padding: 0,
              width: 6,
              height: 6,
              borderRadius: '50% 50% 50% 0',
              backgroundColor: '#52af77',
              transformOrigin: 'bottom left',
              transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
              '&::before': { display: 'none' },
              '&.MuiSlider-valueLabelOpen': {
                transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
              },
              '& > *': {
                transform: 'rotate(45deg)',
              },
            },
          }
        ),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            // borderRadius: '4px',
            // border: '2px solid #13BB34',
            // paddingTop: '5px',
            // paddingRight: '12px',
            // paddingBottom: '5px',
            // paddingLeft: '12px',
            // background: '#FFFFFF',
            // backgroundColor: '#FFFFFF',
            // color: '#B3B3B3',
            // height: '30px',
            // width: '100%',
            // fontFamily: 'Inter-Regular'
            // fontSize: '12px',
            // '&:hover:not(.Mui-disabled, .Mui-error):before': {
            //   borderBottom: '0',
            // },
            // ':focus': {
            //   backgroundColor: '#FFFFFF',
            // },
            // '&.Mui-error': {

            // },
            // '&.Mui-error.Mui-disabled .MuiFilledInput-input': {
            //   color: '#C23838',
            // },
            // '&.Mui-error .MuiFilledInput-input': {
            //   color: '#C23838',
            // },
            // '&:before': {
            //   borderBottom: '0',
            // },
            // '&:after': {
            //   borderBottom: '0',
            // },
          }),
        input: ({ theme }) =>
          theme.unstable_sx({
            // color: '#6E6E6E',
            // fontSize: '14px',
            // fontFamily: 'Inter-Regular',
            // paddingTop: '2px',
            // paddingRight: '4px',
            // paddingBottom: '2px',
            // paddingLeft: '4px',
            // ':focus': {
            //   backgroundColor: '#FFFFFF',
            // },
        }),
      },
    },
    // MuiIconButton: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         '&:not(.button-edit)': {
    //           borderRadius: '10px',
    //           width: '30px',
    //           height: '30px',
    //           padding: '9px',
    //           // background: theme.palette.primary.main,
    //           // '&:hover': {
    //           //   background: theme.palette.secondary.main,
    //           // },
    //         },
    //       }),
    //   },
    // },
    // MuiInputLabel: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         // fontSize: '12px',
    //         // lineHeight: '16px',
    //         // color: '#6E6E6E',
    //         // marginTop: '0px',
    //         // zIndex: 100,
    //         transform: 'translate(14px, 7px) scale(1)',
    //         fontFamily: 'Inter-Medium',
    //         '&.Mui-focused': {
    //           transform: 'translate(13px, -10px) scale(0.75)',
    //           // marginTop: '-6px',
    //           // marginLeft: '6px',
    //         },
    //         '&.MuiFormLabel-filled': {
    //           transform: 'translate(13px, -10px) scale(0.75)',
    //         },
    //       }),
    //   },
    // },
    // MuiCheckbox: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         padding: '0px',
    //       }),
    //   },
    // },
    // MuiFormControlLabel: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         marginLeft: '0px',
    //         marginRight: '0px'
    //       }),
    //   },
    // },
    // MuiTypography: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         fontFamily: 'Inter-Light',
    //         fontSize: '12px',
    //         lineHeight: '1px'
    //       }),
    //   },
    // },
    // MuiPickersDay: {
    //   styleOverrides: {
    //     root: ({ theme }) =>
    //       theme.unstable_sx({
    //         '&.Mui-selected': {
    //           color: '#FFFFFF'
    //         }
    //       }),
    //   },
    // },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            // color: '#6E6E6E',
            // fontSize: '14px',
            // fontFamily: 'Inter-Regular',
            // padding: '2px 8px',
            // paddingTop: '2px',
            // paddingRight: '6px',
            // paddingBottom: '2px',
            // paddingLeft: '6px',
        }),
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: ({ theme }) =>
          theme.unstable_sx({
            // color: '#6E6E6E',
            // fontSize: '14px',
            // fontFamily: 'Inter-Regular',
            // paddingTop: '2px',
            // paddingRight: '6px',
            // paddingBottom: '2px',
            // paddingLeft: '6px',
            // padding: '2px 6px !important'
        }),
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            // '&:not(.button-text)': {
            //   borderRadius: '4px',
            //   // fontSize: '12px',
            //   color: '#FFFFFF',
            //   background: theme.palette.primary.main,
            //   boxShadow: 'none',
            //   '&:hover': {
            //     boxShadow: 'none',
            //     background: theme.palette.secondary.main,
            //   },
            //   '&.Mui-disabled': {
            //     background: theme.palette.secondary.main,
            //   },
            // },
            // textTransform: 'none',
            // fontFamily: 'Inter-Medium',
          }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            // fontFamily: 'Inter-Regular',
          }),
      },
    },
    MuiBox: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            // fontFamily: 'Inter-Regular',
          }),
      },
    },
  },
}, ruRU );

export default theme;